module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Trash-7a3f6c6d1468f775ad6229e460437dfa.svg";